import { MenuItem } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../../common/ChameleonElement';
export class MenuItemComponent extends ChameleonElementMixin(MenuItem) {
    constructor() {
        super(...arguments);
        this.handleChangeEvent = (_e) => {
            this.$emit('menuitemclick', null, { bubbles: true, cancelable: true });
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('change', this.handleChangeEvent);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('change', this.handleChangeEvent);
    }
}
